var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _path, _defs16, _defs17, _path2, _defs18, _defs19, _defs20, _path3, _path4, _defs21, _path5, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg40401(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    viewBox: "0 0 962.7 599.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st15{fill:#f4d2c6}.st22{fill:teal}.st25{fill:#f08f3c}.st35{fill:#4292f3}.st36{fill:#fff}.st37{fill:#152e60}.st38{fill:#606060}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.7 591.3h844.6c-10.8-114.1 20-312.5-120.5-360.5C587.2 135.7 567 152 391 282c-46.6 34.9-107 30.2-158.7 10.1C163.6 269.9 102.2 311 66 367.6c-54.6 57.9-11.8 158.1 1.7 223.7z",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#f2f2f2"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M532.1 423.4H393.8c4.2-8.7 8.5-9.7 16.9-12 1.7-1.2 2.3-3.4 2.9-5.4 10.5-29.1 50.7-23 66.1-1 6.1-2.9 13.8-5.8 19.2-1.6 3.3 2.5 4.9 7.2 8.8 8.4 2.8.9 5.7-.3 8.6-.6 5.6-.5 14 6.8 15.8 12.2z",
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#04afaa"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M744.2 414.8h-74.8c1.6-3.2 4.8-5.1 8.4-5.6 3.9-16.2 25.7-15.3 35.3-4.5 3.4-5.1 10-.7 12.6 3.2 6.7-6.5 15.9-.9 18.5 6.9z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#04afaa"
    }
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M627.2 157.1h-74.8c1.6-3.2 4.8-5.1 8.4-5.6 3.9-16.2 25.7-15.3 35.3-4.5 3.4-5.1 10-.7 12.6 3.2 6.7-6.5 15.9-.9 18.5 6.9z",
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#04afaa"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M495.6 157.2h-79.8c1.9-2.9 3.8-4.5 7.2-5.5 5-19.2 30.9-19.2 43-6.4 4.5-6 14.4-2.9 14.7 4.6 5.2-1.9 12.8 2.1 14.9 7.3z",
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "#04afaa"
    }
  }), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.9 589.8c-34.4-.2-61.4 6.7-78.9-33 14-.3 26.4 9 37.5 17.9-13-12-16.4-31.9-15.4-49.9 14.5 12.8 28.3 27.4 35.8 45.6-1.1-13.6-2.2-27.6 2.1-40.5a74.5 74.5 0 0 1 18.9 59.9z",
    style: {
      clipPath: "url(#SVGID_14_)",
      fill: "#025b59"
    }
  }), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M919.4 589.8s38.1-9.1 45.8-40.8c0 0-28.2 5.8-36.8 15.6 0 0 22.7-26.8 21-60.7 0 0-34.2 19.6-36.4 45.1 0 0-1-34.7-27.5-62.4 0 0-7.2 43.2 3.5 71.4 0 0-21.4-20.1-44.1-24.6 0 0-.4 34.8 33.8 40.6 0 0-17.5-8-39.4-6.7 21.7 22.7 42.1 24 80.1 22.5z",
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "#025b59"
    }
  }), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m137.4 574.2 1.3 5.2 14.9 6.9c1.8.8 2.9 2.7 2.9 4.8h-30.8l1.2-16.9h10.5z",
    style: {
      clipPath: "url(#SVGID_18_)",
      fill: "#152e60"
    }
  }), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m68.3 574.2 1.3 5.2 14.9 6.9c1.8.8 2.9 2.7 2.9 4.8H56.8l1.2-16.9h10.3z",
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "#152e60"
    }
  }), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_22_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000131357406444780977350000008696107071176627346_",
    d: "m125.9 288.2 31 27.1 5.9-55.6 13.2-1.4 3.9 70.5c.3 5.4-1.6 10.7-5.1 14.6-5.1 5.6-13 7.2-19.6 4l-40.9-18.9 11.6-40.3z",
    style: {
      fill: "#f99747"
    }
  }), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "m125.9 288.2 31 27.1 5.9-55.6 13.2-1.4 3.9 70.5c.3 5.4-1.6 10.7-5.1 14.6-5.1 5.6-13 7.2-19.6 4l-40.9-18.9 11.6-40.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.4 290.3s23.6 29 26.9 57.1c3.3 28.2 0 0 0 0l-29.7-9.1 2.8-48",
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "#f99747"
    }
  })), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m156 453.8-15-76.3H76.9L56.8 577.2h14.6L110 429.4l15.2 35.8.4 112.5H141l15.2-113.3a29 29 0 0 0-.2-10.6z",
    style: {
      clipPath: "url(#SVGID_26_)",
      fill: "teal"
    }
  }), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m110 429.4 5.6-23.9c26.3 68.9 22.4 52.4 9.8 124.5l-.3-64.8-15.1-35.8z",
    style: {
      clipPath: "url(#SVGID_28_)",
      fill: "#025b59"
    }
  }), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_30_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000003827132378449912810000004942264167061875384_",
    d: "m110.4 285.5 1.8-17.6c-15.7-19.9 8.8-46 24.1-24.7 8.6 13.4 6.1 35.8-10.4 33.4l2.6 13.6-18.1-4.7z",
    className: "st15"
  })), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "m110.4 285.5 1.8-17.6c-15.7-19.9 8.8-46 24.1-24.7 8.6 13.4 6.1 35.8-10.4 33.4l2.6 13.6-18.1-4.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.8 276.7s-3.6-1.7-4.4-4c0 0 10.2 4.6 16.4-.8s-4 7.2-12 4.8",
    style: {
      clipPath: "url(#SVGID_32_)",
      fill: "#eda19d"
    }
  }), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "m110.4 285.5 1.8-17.6c-15.7-19.9 8.8-46 24.1-24.7 8.6 13.4 6.1 35.8-10.4 33.4l2.6 13.6-18.1-4.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123 252.1s5.8-9.2 17.2-4.8c0 0-5.2-9.5-7.5-10.5-2.3-1.1-8.2 5.8-8.2 5.8l-1.5 9.5z",
    style: {
      clipPath: "url(#SVGID_34_)",
      fill: "#eda19d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8 251.5s3.7-13.1 9.3-12c-8.8-15.5-37.7 2.4-30.1 19.2 3.1 5.9 8.8 12.5 8.8 12.5s5.6-.9 5.6-1.8l2-10.8 4.4-7.1z",
    style: {
      fill: "#59445a"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.3 256.2c-1.4 5.1-8.8 2.6-7.2-2.4 1.3-5.1 8.8-2.7 7.2 2.4z",
    className: "st15"
  }))), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m144.3 376.9-15.7-89.7-18.4-11.4c-30.7 5.7-38.5 105.3-39.7 115.1.1 0 37.3 13 73.8-14z",
    style: {
      clipPath: "url(#SVGID_36_)",
      fill: "#f99747"
    }
  }), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m128.7 287.1-1.8 1.6 6.2 55.3 15.5 13.5-1.1-21.4z",
    style: {
      clipPath: "url(#SVGID_38_)",
      fill: "#324d90"
    }
  }), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_40_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m239.9 259.4-52.3.3.5-26.1 52.3-.4z",
    className: "st22"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m187.8 256.1-31.6.2.3-18.9 31.6-.3z",
    style: {
      fill: "#025b59"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m156.3 251.3-24 .1.1-9 24.1-.1zM243.4 262.7h-5.3l.5-33h5.2z",
    className: "st22"
  }))), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_42_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m241.7 366.2-44.5 7.8c-4.9.8-9.1 4.3-11.2 9.1l-12.5 28 5.8 8.4 14.4-30.1a12 12 0 0 1 6.8-6.1l43.4-13.7c.8-1.7-.5-3.8-2.2-3.4zM91.6 487.6l19.5-44c2.1-4.8 6.3-8.2 11.2-9.1l28.4-5 5.8 8.4-30.8 6.5c-3 .6-5.6 2.5-7.2 5.3L94 490.8c-1.7.5-3.2-1.5-2.4-3.2z",
    className: "st25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m156.7 438-6-8.5 22.7-18.4 5.9 8.6z",
    style: {
      fill: "#2a437d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8 369.6C196 408.8 142.2 452.3 94 490.8c47.8-39.2 101.6-82.7 149.8-121.2z",
    style: {
      fill: "#324d90"
    }
  })), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m128.7 287.1-5.6 4.7s-16.8-7.7-12.7-16.1l18.3 11.4z",
    style: {
      clipPath: "url(#SVGID_44_)",
      fill: "#fff"
    }
  }), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.1 259.7c.3-.3-8.3-15.2-.9-9.7l5.1 6.1 8.5-1.3-1.9 3.6-10.8 1.3z",
    style: {
      clipPath: "url(#SVGID_46_)",
      fill: "#f4d2c6"
    }
  }), _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m114.2 300.9 3.3 56.6 47.9 56.7-11.5 9.5c-6.1-5.6-54.4-39.7-57.4-46.6-9.3-11-7.3-47.8-9.3-61.5l27-14.7z",
    style: {
      clipPath: "url(#SVGID_48_)",
      fill: "#f99747"
    }
  }), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.4 391.8c-22.3-17.8-22-25.8-23.7-53.4-4.5 29.4-13.8 38.6 18 54.5l5.7-1.1z",
    style: {
      clipPath: "url(#SVGID_50_)",
      fill: "#d54a41"
    }
  }), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m137.7 381.3-20.2-23.8-1.4-22.6 8 22.6 17.2 21.5z",
    style: {
      clipPath: "url(#SVGID_52_)",
      fill: "#d54a41"
    }
  }), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.2 415.3s6.8 1.1 7.8 2.4a49 49 0 0 1 2.2 9.3 5 5 0 0 1-2.4 5.1c-13 7.4-9.6 3.8-16-9.3l8.4-7.5z",
    style: {
      clipPath: "url(#SVGID_54_)",
      fill: "#f4d2c6"
    }
  }), _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_55_",
    d: "M-6.8-1.3h972v616h-972z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_56_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m201.2 497.7-1 4.1-6.9-7.9 1-4.1z",
    className: "st35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m202.2 493.6-1 4.1-6.9-7.9 1-4.1z",
    className: "st36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m203.2 489.6-1 4-6.9-7.9 1-4z",
    className: "st35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m204.1 485.5-.9 4.2-6.9-7.9 1-4.2z",
    className: "st36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m205.1 481.5-1 4-6.8-7.8 1-4.1zM214.4 483.4l1-4.2-9.4 2.6-1 4z",
    className: "st35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m213.4 487.4 1-4-9.4 2.5-1.1 4z",
    className: "st36"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m212.4 491.4 1-4-9.5 2.5-1 4.1z",
    className: "st35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m211.3 495.5 1.1-4.1-9.5 2.6-1 4z",
    className: "st36"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m210.3 499.5 1-4-9.4 2.5-1 4z",
    className: "st35"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.6 481.9 180 590.1h-2.3l26.7-108.9zM189.5 452.5l.3-4.2c-12 6.1-6.7 6.5-17.7-1.4l-.3 4.2-.3 4.1-.3 4.2-.3 4.2 7.4 5.6-7.4-5.6-.3 4.2 7.4 5.6-5.3 116.6h2.2l5.5-116.4 8-4.3.3-4.2.3-4.2.3-4.2.2-4.2-8 4.4 8-4.4z",
    className: "st37"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m164.3 493.9.1 4.2-8.5-5.2-.1-4.3z",
    className: "st35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.3 489.7v4.2l-8.5-5.3-.1-4.2z",
    className: "st36"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m164.2 485.4.1 4.3-8.6-5.3v-4.2z",
    className: "st35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m164.1 481.2.1 4.3-8.5-5.3-.1-4.3z",
    className: "st36"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.1 477v4.2l-8.5-5.3-.1-4.2zM173.4 475.7l-.1-4.3-8.4 5.6.1 4.2z",
    className: "st35"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m173.5 479.9-.1-4.2-8.4 5.5.1 4.3z",
    className: "st36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m173.5 484.1-.1-4.2-8.3 5.6v4.2z",
    className: "st35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m173.6 488.3-.1-4.2-8.4 5.6v4.2z",
    className: "st36"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M173.6 492.5v-4.2l-8.5 5.6.1 4.2z",
    className: "st35"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m165.6 477 1.6 113.2h-2.3L163.4 477z",
    className: "st37"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M519.3 179.1 468 257.9h49.6v-40.1h32.2v40.1h19.5v27.5h-19.5v17.3h-32.2v-17.3h-93.3v-21.1l55.8-85.2h39.2zM689.3 179.1a37 37 0 0 1 26.8 10.6 34 34 0 0 1 11 25.5v51.4c0 10-3.7 18.5-11 25.5s-16.3 10.6-26.8 10.6h-66.7a37.2 37.2 0 0 1-37.8-36.1v-51.4a34 34 0 0 1 11-25.5c7.4-7 16.3-10.6 26.8-10.6h66.7zm-68 31.7a13 13 0 0 0-4.4 10.2v39.7c0 4 1.5 7.4 4.4 10.3 2.9 2.7 6.5 4.1 10.7 4.2h47.8c4.2-.2 7.8-1.6 10.7-4.2a14 14 0 0 0 4.4-10.2V221c0-4.2-1.5-7.6-4.4-10.3a14 14 0 0 0-10.7-4.2H632c-4.2 0-7.8 1.4-10.7 4.3zM837.6 179.1l-51.3 78.8h49.6v-40.1h32.2v40.1h19.5v27.5h-19.5v17.3h-32.2v-17.3h-93.3v-21.1l55.8-85.2h39.2zM452.7 335.5c1.9 0 3.6.4 5.1 1.3a9.8 9.8 0 0 1 5.1 8.5c0 1.8-.5 3.4-1.4 4.9s-2.1 2.7-3.7 3.5c-1.6.9-3.3 1.3-5.1 1.3h-19.3v8.9H426v-28.4h26.7zm-19.3 13.3H452c1.1 0 1.9-.4 2.6-1 .7-.7 1-1.5 1-2.5s-.3-1.9-1-2.5c-.7-.7-1.5-1-2.6-1h-18.6v7zM483 339.2l15 24.8h-7.5l-3.2-5.3h-15.2l-3.2 5.3h-7.5l15-24.8h6.6zm-7.4 13.7h8.2l-4.1-6.8-4.1 6.8zM533.1 339.2v6H510c-.7 0-1.3.2-1.9.7-.5.5-.8 1.1-.8 1.8v7.8c0 .7.3 1.3.8 1.8.5.4 1.1.7 1.8.7h16.9v-3.1H519v-5.8h14.8V364h-25.7c-2.1 0-4-.7-5.5-2.2a7 7 0 0 1-2.3-5.2v-10.1a7 7 0 0 1 2.3-5.2 8 8 0 0 1 5.5-2.2h25v.1zM566.5 339.2v6h-22.1v3.3h19.2v5.9h-19.2v3.5h22.1v6h-29.1v-24.8h29.1v.1zM596.6 339.2l19.4 16.5v-16.5h7V364h-6.8l-19.4-16.5V364h-7v-24.8h6.8zM652.3 339.2c2.2 0 4 .7 5.5 2.2a7 7 0 0 1 2.3 5.2v10.1c0 2-.7 3.8-2.3 5.2a7.7 7.7 0 0 1-5.5 2.1h-18c-2.1 0-3.9-.7-5.5-2.2a7 7 0 0 1-2.3-5.2v-10.1a7 7 0 0 1 2.3-5.2 8 8 0 0 1 5.5-2.2h18v.1zm-18 6.7c-.5.5-.8 1.1-.8 1.8v7.8c0 .7.3 1.3.8 1.8.5.4 1.1.7 1.8.7h14.3a3 3 0 0 0 1.9-.7c.5-.5.8-1.1.8-1.8v-7.8c0-.7-.3-1.3-.8-1.8s-1.1-.7-1.8-.7h-14.3c-.8 0-1.4.2-1.9.7zM694.5 339.2v6h-11.9V364h-7v-18.8h-11.9v-6h30.8zM746.2 339.2v6h-21.4v4h18.5v5.9h-18.5v8.8h-7v-24.8h28.4v.1zM775.5 339.2c2.2 0 4 .7 5.5 2.2a7 7 0 0 1 2.3 5.2v10.1c0 2-.7 3.8-2.3 5.2a7.7 7.7 0 0 1-5.5 2.1h-18c-2.1 0-3.9-.7-5.5-2.2a7 7 0 0 1-2.3-5.2v-10.1a7 7 0 0 1 2.3-5.2 8 8 0 0 1 5.5-2.2h18v.1zm-18 6.7c-.5.5-.8 1.1-.8 1.8v7.8c0 .7.3 1.3.8 1.8.5.4 1.1.7 1.8.7h14.3a3 3 0 0 0 1.9-.7c.5-.5.8-1.1.8-1.8v-7.8c0-.7-.3-1.3-.8-1.8s-1.1-.7-1.8-.7h-14.3c-.8 0-1.4.2-1.9.7zM793.8 339.2v16.3c0 .7.3 1.3.8 1.8.5.4 1.1.7 1.8.7h12.8c.7 0 1.4-.3 1.9-.7.5-.5.8-1.1.8-1.8v-16.3h7v17.4c0 2-.7 3.8-2.3 5.2a7.8 7.8 0 0 1-5.5 2.2h-16.5c-2.1 0-4-.7-5.5-2.2s-2.3-3.2-2.3-5.2v-17.4h7zM829.2 339.2l19.4 16.5v-16.5h7V364h-6.8l-19.4-16.5V364h-7v-24.8h6.8zM884 339.2c2.2 0 4.1.7 5.8 2.2s2.5 3.2 2.5 5.2v10.1c0 2-.8 3.8-2.5 5.2a8.9 8.9 0 0 1-5.7 2.2h-24.8v-24.8H884v-.1zm-17.8 18.7h16.5c.7 0 1.3-.3 1.9-.7.5-.5.8-1.1.8-1.8v-7.8c0-.7-.3-1.3-.8-1.8s-1.1-.7-1.8-.7h-16.5v12.8h-.1z",
    className: "st38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M738.5 249.9h-74.8c1.6-3.2 4.8-5.1 8.4-5.6 3.9-16.2 25.7-15.3 35.3-4.5 3.4-5.1 10-.7 12.6 3.2 6.7-6.5 15.9-.9 18.5 6.9z",
    style: {
      fill: "#04afaa"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg40401);
export default __webpack_public_path__ + "static/media/404-01.f1ee3c5378f2b4fa585a448ae7bfadaa.svg";
export { ForwardRef as ReactComponent };